import React from 'react';
import { Typography } from '@mui/material';

import { cropString } from 'modules/common';

interface Props {
  address: string;
}

export function AddressCell({ address }: Props): JSX.Element {
  return <Typography variant="subtitle3">{cropString(address, 7)}</Typography>;
}
